import { Component } from '@angular/core';

@Component({
  selector: 'fgb-fantasy-game-rules-v2',
  templateUrl: './fantasy-game-rules-v2.component.html',
  styleUrl: './fantasy-game-rules-v2.component.scss',
})
export class FantasyGameRulesV2Component {}
